export default "__VITE_ASSET__DZFMiSO2__"